export default "__VITE_ASSET__P$Wz9Rs3__"